import { useSelector } from "react-redux";

import { StoreState } from "store";
import { ThemeName } from "store/theme";

export function useTheme() {
    return useSelector((state: StoreState) => state.themeReducer.theme);
}

export function useThemeName() {
    return useSelector((state: StoreState) => state.themeReducer.themeName);
}

export function useIsDarkThemeActive(): boolean {
    const themeName = useThemeName();
    return (
        themeName === ThemeName.DEFAULT_DARK ||
        themeName === ThemeName.SUB_TENANT_DARK ||
        themeName === ThemeName.TENANT_DARK
    );
}
